// removed by extract-text-webpack-plugin
module.exports = {"user_custom_form":"User__user_custom_form___1uFfZ","label_checkbox":"User__label_checkbox___3eZFp"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/User/User.scss
 ** module id = 1359
 ** module chunks = 0
 **/